import React from 'react';
import styles from './sections.module.css';

interface HeroSectionProps {
  project: any;
}

export const HeroSection: React.FC<HeroSectionProps> = ({ project }) => {
  const pw = project.publicWebsite;
  const hero = pw?.hero || {};
  const title = hero.title || project.name;
  const subtitle = hero.subtitle || project.description;
  const heroImage = hero.heroImage || project.headerImage;
  const stats = hero.stats || [];

  return (
    <section
      id="hero"
      className={styles.hero}
      style={heroImage ? { backgroundImage: `url(${heroImage})` } : undefined}
    >
      <div className={styles.heroOverlay} />
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>{title}</h1>
        {subtitle && <p className={styles.heroSubtitle}>{subtitle}</p>}
        {hero.ctaText && (
          <a href={hero.ctaLink || '#about'} className={styles.heroCta}>
            {hero.ctaText}
          </a>
        )}
        {stats.length > 0 && (
          <div className={styles.heroStats}>
            {stats.map((stat: any, i: number) => (
              <div key={i} className={styles.heroStat}>
                <span className={styles.heroStatValue}>{stat.value}</span>
                <span className={styles.heroStatLabel}>{stat.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
